'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { Sparkles, X } from 'lucide-react';
import { UpdateFeedEntry } from 'types/common';
import { ROUTES } from '#/data/constants';
import {
  isUpdateFeedNew,
  markUpdateFeedSeen,
  UPDATE_FEED_SEEN_EVENT
} from '#/lib/update-feed-seen';

interface RecentUpdateChipProps {
  entry: UpdateFeedEntry;
}

export function RecentUpdateChip({ entry }: RecentUpdateChipProps) {
  // SSR/hydration mismatch 방지: 마운트 후에만 표시 여부 결정
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => setVisible(isUpdateFeedNew(entry.date));
    check();
    window.addEventListener(UPDATE_FEED_SEEN_EVENT, check);
    return () => window.removeEventListener(UPDATE_FEED_SEEN_EVENT, check);
  }, [entry.date]);

  if (!visible) return null;

  return (
    <div className="flex items-center justify-center gap-2 rounded-lg border border-[#104573]/15 bg-[#104573]/5 px-3 py-2 text-xs sm:text-sm text-[#104573] dark:border-[#60a3d9]/20 dark:bg-[#60a3d9]/10 dark:text-[#cfe2f3]">
      <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-[#104573] px-2 py-0.5 text-[10px] font-semibold leading-none text-white dark:bg-[#60a3d9] dark:text-[#0c1a2e]">
        <Sparkles className="h-3 w-3" />더 바르게
      </span>
      <span className="min-w-0 truncate">{entry.title}</span>
      <Link
        href={`${ROUTES.UPDATE_LOGS}?view=recent`}
        className="shrink-0 font-medium underline underline-offset-2 hover:text-[#0b3559] dark:hover:text-white"
      >
        자세히 보기
      </Link>
      <button
        type="button"
        aria-label="최근 업데이트 알림 닫기"
        onClick={() => {
          markUpdateFeedSeen(entry.date);
          setVisible(false);
        }}
        className="shrink-0 rounded-md p-0.5 text-[#104573]/60 transition hover:bg-[#104573]/10 hover:text-[#104573] dark:text-white/60 dark:hover:bg-white/10 dark:hover:text-white"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
